import { render } from "./move.vue?vue&type=template&id=775b7c1c&lang=pug"
import script from "./move.vue?vue&type=script&setup=true&lang=js"
export * from "./move.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__